import Permissions from 'src/security/permissions';

const permissions = Permissions.values;

const privateRoutes = [  
  {
    path: '/admin',
    loader: () =>
      import('src/view/event/list/EventListPage'),
    permissionRequired: permissions.eventRead,
    exact: true,
  },

  {
    path: '/admin/profile',
    loader: () => import('src/view/auth/ProfileFormPage'),
    permissionRequired: null,
    exact: true,
  },

  {
    path: '/admin/password-change',
    loader: () =>
      import('src/view/auth/PasswordChangeFormPage'),
    permissionRequired: null,
    exact: true,
  },

  {
    path: '/admin/tenant',
    loader: () =>
      import('src/view/tenant/list/TenantListPage'),
    permissionRequired: null,
    exact: true,
  },
  {
    path: '/admin/tenant/new',
    loader: () =>
      import('src/view/tenant/form/TenantFormPage'),
    permissionRequired: null,
    exact: true,
  },
  {
    path: '/admin/tenant/:id/edit',
    loader: () =>
      import('src/view/tenant/form/TenantFormPage'),
    permissionRequired: null,
    exact: true,
  },

  {
    path: '/admin/user',
    loader: () => import('src/view/user/list/UserPage'),
    permissionRequired: permissions.userRead,
    exact: true,
  },

  {
    path: '/admin/user/new',
    loader: () => import('src/view/user/new/UserNewPage'),
    permissionRequired: permissions.userCreate,
    exact: true,
  },

  {
    path: '/admin/user/importer',
    loader: () =>
      import('src/view/user/importer/UserImporterPage'),
    permissionRequired: permissions.userImport,
    exact: true,
  },
  {
    path: '/admin/user/:id/edit',
    loader: () => import('src/view/user/edit/UserEditPage'),
    permissionRequired: permissions.userEdit,
    exact: true,
  },
  {
    path: '/admin/user/:id',
    loader: () => import('src/view/user/view/UserViewPage'),
    permissionRequired: permissions.userRead,
    exact: true,
  },

  {
    path: '/admin/settings',
    loader: () =>
      import('src/view/settings/SettingsFormPage'),
    permissionRequired: permissions.settingsEdit,
  },

  {
    path: '/admin/event',
    loader: () =>
      import('src/view/event/list/EventListPage'),
    permissionRequired: permissions.eventRead,
    exact: true,
  },
  {
    path: '/admin/event/new',
    loader: () =>
      import('src/view/event/form/EventFormPage'),
    permissionRequired: permissions.eventCreate,
    exact: true,
  },
  {
    path: '/admin/event/importer',
    loader: () =>
      import(
        'src/view/event/importer/EventImporterPage'
      ),
    permissionRequired: permissions.eventImport,
    exact: true,
  },
  {
    path: '/admin/event/ai-chat',
    loader: () =>
      import(
        'src/view/event/aiChat/EventAiChatPage'
      ),
    permissionRequired: permissions.eventImport,
    exact: true,
  },
  {
    path: '/admin/event/:id/edit',
    loader: () =>
      import('src/view/event/form/EventFormPage'),
    permissionRequired: permissions.eventEdit,
    exact: true,
  },
  {
    path: '/admin/event/:id',
    loader: () =>
      import('src/view/event/view/EventViewPage'),
    permissionRequired: permissions.eventRead,
    exact: true,
  },

  {
    path: '/admin/tag',
    loader: () =>
      import('src/view/tag/list/TagListPage'),
    permissionRequired: permissions.tagRead,
    exact: true,
  },
  {
    path: '/admin/tag/new',
    loader: () =>
      import('src/view/tag/form/TagFormPage'),
    permissionRequired: permissions.tagCreate,
    exact: true,
  },
  {
    path: '/admin/tag/importer',
    loader: () =>
      import(
        'src/view/tag/importer/TagImporterPage'
      ),
    permissionRequired: permissions.tagImport,
    exact: true,
  },
  {
    path: '/admin/tag/:id/edit',
    loader: () =>
      import('src/view/tag/form/TagFormPage'),
    permissionRequired: permissions.tagEdit,
    exact: true,
  },
  {
    path: '/admin/tag/:id',
    loader: () =>
      import('src/view/tag/view/TagViewPage'),
    permissionRequired: permissions.tagRead,
    exact: true,
  },

  {
    path: '/admin/category',
    loader: () =>
      import('src/view/category/list/CategoryListPage'),
    permissionRequired: permissions.categoryRead,
    exact: true,
  },
  {
    path: '/admin/category/new',
    loader: () =>
      import('src/view/category/form/CategoryFormPage'),
    permissionRequired: permissions.categoryCreate,
    exact: true,
  },
  {
    path: '/admin/category/importer',
    loader: () =>
      import(
        'src/view/category/importer/CategoryImporterPage'
      ),
    permissionRequired: permissions.categoryImport,
    exact: true,
  },
  {
    path: '/admin/category/:id/edit',
    loader: () =>
      import('src/view/category/form/CategoryFormPage'),
    permissionRequired: permissions.categoryEdit,
    exact: true,
  },
  {
    path: '/admin/category/:id',
    loader: () =>
      import('src/view/category/view/CategoryViewPage'),
    permissionRequired: permissions.categoryRead,
    exact: true,
  },

  {
    path: '/admin/event-class',
    loader: () =>
      import('src/view/eventClass/list/EventClassListPage'),
    permissionRequired: permissions.eventClassRead,
    exact: true,
  },
  {
    path: '/admin/event-class/new',
    loader: () =>
      import('src/view/eventClass/form/EventClassFormPage'),
    permissionRequired: permissions.eventClassCreate,
    exact: true,
  },
  {
    path: '/admin/event-class/importer',
    loader: () =>
      import(
        'src/view/eventClass/importer/EventClassImporterPage'
      ),
    permissionRequired: permissions.eventClassImport,
    exact: true,
  },
  {
    path: '/admin/event-class/:id/edit',
    loader: () =>
      import('src/view/eventClass/form/EventClassFormPage'),
    permissionRequired: permissions.eventClassEdit,
    exact: true,
  },
  {
    path: '/admin/event-class/:id',
    loader: () =>
      import('src/view/eventClass/view/EventClassViewPage'),
    permissionRequired: permissions.eventClassRead,
    exact: true,
  },

  {
    path: '/admin/event-time-zone',
    loader: () =>
      import('src/view/eventTimeZone/list/EventTimeZoneListPage'),
    permissionRequired: permissions.eventTimeZoneRead,
    exact: true,
  },
  {
    path: '/admin/event-time-zone/new',
    loader: () =>
      import('src/view/eventTimeZone/form/EventTimeZoneFormPage'),
    permissionRequired: permissions.eventTimeZoneCreate,
    exact: true,
  },
  {
    path: '/admin/event-time-zone/importer',
    loader: () =>
      import(
        'src/view/eventTimeZone/importer/EventTimeZoneImporterPage'
      ),
    permissionRequired: permissions.eventTimeZoneImport,
    exact: true,
  },
  {
    path: '/admin/event-time-zone/:id/edit',
    loader: () =>
      import('src/view/eventTimeZone/form/EventTimeZoneFormPage'),
    permissionRequired: permissions.eventTimeZoneEdit,
    exact: true,
  },
  {
    path: '/admin/event-time-zone/:id',
    loader: () =>
      import('src/view/eventTimeZone/view/EventTimeZoneViewPage'),
    permissionRequired: permissions.eventTimeZoneRead,
    exact: true,
  },

  {
    path: '/admin/country',
    loader: () =>
      import('src/view/country/list/CountryListPage'),
    permissionRequired: permissions.countryRead,
    exact: true,
  },
  {
    path: '/admin/country/new',
    loader: () =>
      import('src/view/country/form/CountryFormPage'),
    permissionRequired: permissions.countryCreate,
    exact: true,
  },
  {
    path: '/admin/country/importer',
    loader: () =>
      import(
        'src/view/country/importer/CountryImporterPage'
      ),
    permissionRequired: permissions.countryImport,
    exact: true,
  },
  {
    path: '/admin/country/:id/edit',
    loader: () =>
      import('src/view/country/form/CountryFormPage'),
    permissionRequired: permissions.countryEdit,
    exact: true,
  },
  {
    path: '/admin/country/:id',
    loader: () =>
      import('src/view/country/view/CountryViewPage'),
    permissionRequired: permissions.countryRead,
    exact: true,
  },

  {
    path: '/admin/place',
    loader: () =>
      import('src/view/place/list/PlaceListPage'),
    permissionRequired: permissions.placeRead,
    exact: true,
  },
  {
    path: '/admin/place/new',
    loader: () =>
      import('src/view/place/form/PlaceFormPage'),
    permissionRequired: permissions.placeCreate,
    exact: true,
  },
  {
    path: '/admin/place/importer',
    loader: () =>
      import(
        'src/view/place/importer/PlaceImporterPage'
      ),
    permissionRequired: permissions.placeImport,
    exact: true,
  },
  {
    path: '/admin/place/:id/edit',
    loader: () =>
      import('src/view/place/form/PlaceFormPage'),
    permissionRequired: permissions.placeEdit,
    exact: true,
  },
  {
    path: '/admin/place/:id',
    loader: () =>
      import('src/view/place/view/PlaceViewPage'),
    permissionRequired: permissions.placeRead,
    exact: true,
  },
  {
    path: '/admin/event-schedule',
    loader: () =>
      import('src/view/eventSchedule/list/EventScheduleListPage'),
    permissionRequired: permissions.eventScheduleRead,
    exact: true,
  },
  {
    path: '/admin/event-schedule/new',
    loader: () =>
      import('src/view/eventSchedule/form/EventScheduleFormPage'),
    permissionRequired: permissions.eventScheduleCreate,
    exact: true,
  },
  {
    path: '/admin/event-schedule/importer',
    loader: () =>
      import(
        'src/view/eventSchedule/importer/EventScheduleImporterPage'
      ),
    permissionRequired: permissions.eventScheduleImport,
    exact: true,
  },
  {
    path: '/admin/event-schedule/:id/edit',
    loader: () =>
      import('src/view/eventSchedule/form/EventScheduleFormPage'),
    permissionRequired: permissions.eventScheduleEdit,
    exact: true,
  },
  {
    path: '/contact',
    loader: () =>
      import('src/view/contact/list/ContactListPage'),
    permissionRequired: permissions.contactRead,
    exact: true,
  },
  {
    path: '/contact/new',
    loader: () =>
      import('src/view/contact/form/ContactFormPage'),
    permissionRequired: permissions.contactCreate,
    exact: true,
  },
  {
    path: '/contact/importer',
    loader: () =>
      import(
        'src/view/contact/importer/ContactImporterPage'
      ),
    permissionRequired: permissions.contactImport,
    exact: true,
  },
  {
    path: '/contact/:id/edit',
    loader: () =>
      import('src/view/contact/form/ContactFormPage'),
    permissionRequired: permissions.contactEdit,
    exact: true,
  },
  {
    path: '/contact/:id',
    loader: () =>
      import('src/view/contact/view/ContactViewPage'),
    permissionRequired: permissions.contactRead,
    exact: true,
  },
  {
    path: '/admin/event-schedule/:id',
    loader: () =>
      import('src/view/eventSchedule/view/EventScheduleViewPage'),
    permissionRequired: permissions.eventScheduleRead,
    exact: true,
  },
  {
    path: '/position',
    loader: () =>
      import('src/view/position/list/PositionListPage'),
    permissionRequired: permissions.positionRead,
    exact: true,
  },
  {
    path: '/position/new',
    loader: () =>
      import('src/view/position/form/PositionFormPage'),
    permissionRequired: permissions.positionCreate,
    exact: true,
  },
  {
    path: '/position/importer',
    loader: () =>
      import(
        'src/view/position/importer/PositionImporterPage'
      ),
    permissionRequired: permissions.positionImport,
    exact: true,
  },
  {
    path: '/position/:id/edit',
    loader: () =>
      import('src/view/position/form/PositionFormPage'),
    permissionRequired: permissions.positionEdit,
    exact: true,
  },
  {
    path: '/position/:id',
    loader: () =>
      import('src/view/position/view/PositionViewPage'),
    permissionRequired: permissions.positionRead,
    exact: true,
  },
  {
    path: '/country-state',
    loader: () =>
      import('src/view/countryState/list/CountryStateListPage'),
    permissionRequired: permissions.countryStateRead,
    exact: true,
  },
  {
    path: '/country-state/new',
    loader: () =>
      import('src/view/countryState/form/CountryStateFormPage'),
    permissionRequired: permissions.countryStateCreate,
    exact: true,
  },
  {
    path: '/country-state/importer',
    loader: () =>
      import(
        'src/view/countryState/importer/CountryStateImporterPage'
      ),
    permissionRequired: permissions.countryStateImport,
    exact: true,
  },
  {
    path: '/country-state/:id/edit',
    loader: () =>
      import('src/view/countryState/form/CountryStateFormPage'),
    permissionRequired: permissions.countryStateEdit,
    exact: true,
  },
  {
    path: '/country-state/:id',
    loader: () =>
      import('src/view/countryState/view/CountryStateViewPage'),
    permissionRequired: permissions.countryStateRead,
    exact: true,
  },
].filter(Boolean);

const publicRoutes = [
  {
    path: '/admin/auth/signin',
    loader: () => import('src/view/auth/SigninPage'),
  },
  {
    path: '/admin/auth/signup',
    loader: () => import('src/view/auth/SignupPage'),
  },
  {
    path: '/admin/auth/forgot-password',
    loader: () =>
      import('src/view/auth/ForgotPasswordPage'),
  },  
].filter(Boolean);

const publicRoutesWithLoginOption = [ 
  {
    path: '/',
    loader: () =>
      import('src/view/event/list/EventsUpcomingPage')
  }, 
  {
    path: '/events',
    loader: () =>
      import('src/view/event/list/EventsUpcomingPage'),
    permissionRequired: permissions.eventRead,
    exact: true,
  }, 
  {
    path: '/event-detail/:id',
    loader: () =>
      import('src/view/event/list/EventsUpcomingDetailPage'),
    permissionRequired: permissions.eventRead,
    exact: true,
  },
].filter(Boolean);

const emptyTenantRoutes = [
  {
    path: '/admin/auth/tenant',
    loader: () => import('src/view/auth/TenantPage'),
  },
].filter(Boolean);

const emptyPermissionsRoutes = [
  {
    path: '/admin/auth/empty-permissions',
    loader: () =>
      import('src/view/auth/EmptyPermissionsPage'),
  },
].filter(Boolean);

const emailUnverifiedRoutes = [
  {
    path: '/admin/auth/email-unverified',
    loader: () =>
      import('src/view/auth/EmailUnverifiedPage'),
  },
].filter(Boolean);

const simpleRoutes = [
  {
    path: '/admin/auth/password-reset',
    loader: () => import('src/view/auth/PasswordResetPage'),
  },
  {
    path: '/admin/auth/invitation',
    loader: () => import('src/view/auth/InvitationPage'),
  },
  {
    path: '/admin/auth/verify-email',
    loader: () => import('src/view/auth/VerifyEmailPage'),
  },
  {
    path: '/403',
    loader: () =>
      import('src/view/shared/errors/Error403Page'),
  },
  {
    path: '/500',
    loader: () =>
      import('src/view/shared/errors/Error500Page'),
  },
  {
    path: '**',
    loader: () =>
      import('src/view/shared/errors/Error404Page'),
  },
].filter(Boolean);

const redirectsAdmin = [  
  '/event',
  '/tag',
  '/country',
  '/event-time-zone',
  '/category',
  '/event-class',
  '/place',
  '/event-schedule',
  '/settings',
  '/user',
  '/profile',
  '/password-change',
  '/auth/password-reset',
  '/auth/invitation',
  '/auth/verify-email',
  '/auth/signin',
  '/auth/signup',
  '/auth/ForgotPasswordPage',
  '/tenant'
].filter(Boolean);

export default {
  privateRoutes,
  publicRoutes,
  publicRoutesWithLoginOption,
  emptyTenantRoutes,
  emptyPermissionsRoutes,
  emailUnverifiedRoutes,
  simpleRoutes,
  redirectsAdmin
};
